import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxiosFormData } from "@/redux/api/fetchBaseQueryHelper";

export const uploadApi = createApi({
	reducerPath: "record",
	baseQuery: fetchBaseQueryByAxiosFormData,
	endpoints: (builder) => ({
		uploadSalesReport: builder.mutation({
			query: (initialPost) => {
				const formData = new FormData();
				formData.append("file", initialPost);
				return {
					url: "/upload/salesReport/csv",
					method: "POST",
					body: formData,
				};
			},
		}),
		uploadPickupReport: builder.mutation({
			query: (initialPost) => {
				const formData = new FormData();
				formData.append("file", initialPost);
				return {
					url: "/upload/pickupReport/csv",
					method: "POST",
					body: formData,
				};
			},
		}),
		deleteUploadDataByDate: builder.mutation({
			query: (id) => {
				return {
					url: `/upload/deleteDataByDate?data_date=${id}`,
					method: "DELETE",
				};
			},
		}),
	}),
});

export const {
	useUploadSalesReportMutation,
	useUploadPickupReportMutation,
	useDeleteUploadDataByDateMutation,
} = uploadApi;
